// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Holidays from "../Holidays/index.js";
import * as Intl_NumberFormat from "../Intl.NumberFormat/index.js";
import * as React_Basic_DOM from "../React.Basic.DOM/index.js";
import * as React_Basic_DOM_Client from "../React.Basic.DOM.Client/index.js";
import * as React_Basic_DOM_Generated from "../React.Basic.DOM.Generated/index.js";
import * as React_Basic_Events from "../React.Basic.Events/index.js";
import * as React_Basic_Hooks from "../React.Basic.Hooks/index.js";
import * as React_Basic_Hooks_Internal from "../React.Basic.Hooks.Internal/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Web_DOM_NonElementParentNode from "../Web.DOM.NonElementParentNode/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_HTMLDocument from "../Web.HTML.HTMLDocument/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var toEnum = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumYear);
var greaterThan = /* #__PURE__ */ Data_Ord.greaterThan(Data_Date_Component.ordYear);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Date_Component.eqYear);
var greaterThan1 = /* #__PURE__ */ Data_Ord.greaterThan(Data_Date_Component.ordMonth);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe);
var greaterThanOrEq = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Data_Date_Component.ordYear);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var toEnum1 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumDay);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay);
var fromEnum1 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth);
var fromEnum2 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var li = /* #__PURE__ */ React_Basic_DOM_Generated.li();
var span = /* #__PURE__ */ React_Basic_DOM_Generated.span();
var div = /* #__PURE__ */ React_Basic_DOM_Generated.div();
var h4 = /* #__PURE__ */ React_Basic_DOM_Generated.h4();
var ul = /* #__PURE__ */ React_Basic_DOM_Generated.ul();
var lessThanOrEq = /* #__PURE__ */ Data_Ord.lessThanOrEq(Data_Time_Duration.ordDays);
var diff = /* #__PURE__ */ Data_Date.diff(Data_Time_Duration.durationDays);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var succ = /* #__PURE__ */ Data_Enum.succ(Data_Date.enumDate);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var notEq = /* #__PURE__ */ Data_Eq.notEq(Data_Date_Component.eqWeekday);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Date.eqDate);
var lessThan = /* #__PURE__ */ Data_Ord.lessThan(Data_Date_Component.ordYear);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Date_Component.ordYear);
var lookup1 = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Date.ordDate);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Monoid.monoidArray);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Data_Date_Component.eqMonth);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var bind1 = /* #__PURE__ */ React_Basic_Hooks_Internal.bind(React_Basic_Hooks_Internal.ixBindRender);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ React_Basic_Hooks_Internal.applicativeRender(Type_Equality.refl));
var h2 = /* #__PURE__ */ React_Basic_DOM_Generated.h2();
var bindFlipped1 = /* #__PURE__ */ Control_Bind.bindFlipped(Effect.bindEffect);
var apply1 = /* #__PURE__ */ Control_Apply.apply(Effect.applyEffect);
var taxPercentage = function (date) {
    var v = new Data_Tuple.Tuple(toEnum(2026), Data_Date_Component.February.value);
    if (v.value0 instanceof Data_Maybe.Just) {
        if (greaterThan(Data_Date.year(date))(v.value0.value0)) {
            return 0.0;
        };
        if (eq(Data_Date.year(date))(v.value0.value0) && greaterThan1(Data_Date.month(date))(v.value1)) {
            return 0.0;
        };
        if (Data_Boolean.otherwise) {
            return 7.67e-2;
        };
    };
    return 7.67e-2;
};
var officialCategorySalary = function (date) {
    var v = sequence([ toEnum(2024), toEnum(2025), toEnum(2026) ]);
    if (v instanceof Data_Maybe.Just && v.value0.length === 3) {
        if (greaterThanOrEq(Data_Date.year(date))(v["value0"][2]) && greaterThan1(Data_Date.month(date))(Data_Date_Component.January.value)) {
            return 1668.8;
        };
        if (eq(Data_Date.year(date))(v["value0"][2]) || greaterThanOrEq(Data_Date.year(date))(v["value0"][1]) && greaterThan1(Data_Date.month(date))(Data_Date_Component.January.value)) {
            return 1518.0;
        };
        if (eq(Data_Date.year(date))(v["value0"][1]) || greaterThanOrEq(Data_Date.year(date))(v["value0"][0]) && greaterThan1(Data_Date.month(date))(Data_Date_Component.January.value)) {
            return 1439.23;
        };
        if (Data_Boolean.otherwise) {
            return 1370.7;
        };
    };
    return 1370.7;
};
var monthStart = function (date) {
    return map(Data_Date.canonicalDate(Data_Date.year(date))(Data_Date.month(date)))(toEnum1(1));
};
var monthHolidaysView = function (v) {
    var formatDate = function (d) {
        return show(fromEnum(Data_Date.day(d))) + ("/" + (show(fromEnum1(Data_Date.month(d))) + ("/" + show(fromEnum2(Data_Date.year(d))))));
    };
    var holidayItems = mapFlipped(v.monthHolidays)(function (v1) {
        return li({
            className: "font-extralight mb-3",
            children: [ span({
                className: "font-normal",
                children: [ React_Basic_DOM.text(formatDate(v1.date)) ]
            }), React_Basic_DOM.text(" \u2014 "), React_Basic_DOM.text(v1.name) ]
        });
    });
    var $80 = Data_Array["null"](v.monthHolidays);
    if ($80) {
        return React_Basic_DOM.text("");
    };
    return div({
        children: [ h4({
            className: "p-4 text-center bg-gray-500 text-white mb-4",
            children: [ React_Basic_DOM.text("Feriados") ]
        }), div({
            className: "mx-6 text-xl",
            children: [ ul({
                className: "px-4 list-none",
                children: holidayItems
            }) ]
        }) ]
    });
};
var monthEnd = function (date) {
    var day = Data_Date.lastDayOfMonth(Data_Date.year(date))(Data_Date.month(date));
    return Data_Date.canonicalDate(Data_Date.year(date))(Data_Date.month(date))(day);
};
var monthRange = function (date) {
    var lastDay = monthEnd(date);
    var $82 = lessThanOrEq(diff(lastDay)(date))(3.0);
    if ($82) {
        return bindFlipped(monthRange)(succ(lastDay));
    };
    var firstDay = monthStart(date);
    return apply(map(Data_Tuple.Tuple.create)(firstDay))(new Data_Maybe.Just(lastDay));
};
var monthSelector = function (setRange) {
    return function (refDate) {
        var moveMonths = function (amount) {
            return setRange(function (range) {
                return bind(range)(function (v) {
                    return bind(map(monthEnd)(Data_Date.adjust(amount)((function () {
                        var $84 = amount > 0.0;
                        if ($84) {
                            return v.value1;
                        };
                        return v.value0;
                    })())))(function (newEnd) {
                        return bind(monthStart(newEnd))(function (newStart) {
                            return pure(new Data_Tuple.Tuple(newStart, newEnd));
                        });
                    });
                });
            });
        };
        var monthName = (function () {
            var v = Data_Date.month(refDate);
            if (v instanceof Data_Date_Component.January) {
                return "Janeiro";
            };
            if (v instanceof Data_Date_Component.February) {
                return "Fevereiro";
            };
            if (v instanceof Data_Date_Component.March) {
                return "Mar\xe7o";
            };
            if (v instanceof Data_Date_Component.April) {
                return "Abril";
            };
            if (v instanceof Data_Date_Component.May) {
                return "Maio";
            };
            if (v instanceof Data_Date_Component.June) {
                return "Junho";
            };
            if (v instanceof Data_Date_Component.July) {
                return "Julho";
            };
            if (v instanceof Data_Date_Component.August) {
                return "Agosto";
            };
            if (v instanceof Data_Date_Component.September) {
                return "Setembro";
            };
            if (v instanceof Data_Date_Component.October) {
                return "Outubro";
            };
            if (v instanceof Data_Date_Component.November) {
                return "Novembro";
            };
            if (v instanceof Data_Date_Component.December) {
                return "Dezembro";
            };
            throw new Error("Failed pattern match at Main (line 185, column 15 - line 197, column 27): " + [ v.constructor.name ]);
        })();
        return div({
            className: "w-full bg-gray-500 text-white text-4xl",
            children: [ div({
                className: "flex p-4",
                children: [ div({
                    className: "basis-lg text-4xl cursor-pointer",
                    onClick: React_Basic_Events.handler_(moveMonths(-1.0)),
                    children: [ React_Basic_DOM.text("\u2190") ]
                }), div({
                    className: "grow shrink mx-4 text-center",
                    children: [ React_Basic_DOM.text(monthName + (" " + show(fromEnum2(Data_Date.year(refDate))))) ]
                }), div({
                    className: "basis-lg text-4xl text-right cursor-pointer",
                    onClick: React_Basic_Events.handler_(moveMonths(1.0)),
                    children: [ React_Basic_DOM.text("\u2192") ]
                }) ]
            }) ]
        });
    };
};
var isWorkDay = function (d) {
    return notEq(Data_Date.weekday(d))(Data_Date_Component.Saturday.value) && (notEq(Data_Date.weekday(d))(Data_Date_Component.Sunday.value) && !Holidays.isHoliday(d));
};
var formatAmount = /* #__PURE__ */ Intl_NumberFormat.formatCurrency("pt-BR")("BRL");
var lineItems = function (breakdown) {
    var lineItem = function (desc) {
        return function (amount) {
            return li({
                className: "font-extralight mb-3",
                children: [ span({
                    className: "font-normal",
                    children: [ React_Basic_DOM.text(desc + ": ") ]
                }), React_Basic_DOM.text(formatAmount(amount)) ]
            });
        };
    };
    var additionalCharges = mapFlipped(breakdown.additionalCharges)(function (charge) {
        return lineItem(charge.description)(charge.amount);
    });
    return div({
        className: "mx-6 text-xl",
        children: [ ul({
            className: "p-4 list-none",
            children: append1([ lineItem("Sal\xe1rio base")(breakdown.baseSalary), lineItem("Passagens " + (" (" + (show(breakdown.workDayCount) + (" dias \xfateis \xd7 " + (formatAmount(breakdown.dailyTransportationCosts) + ")")))))(breakdown.transportationCosts), lineItem("Impostos")(breakdown.taxes) ])(additionalCharges)
        }) ]
    });
};
var totalAmount = function (breakdown) {
    return div({
        className: "flex items-center justify-center h-[200px] border-t border-b border-gray-300 text-5xl md:text-6xl text-red-600 font-medium px-8",
        children: [ React_Basic_DOM.text(formatAmount(breakdown.totalAmount)) ]
    });
};
var daysInMonth = function (start) {
    return function (end) {
        var go = function ($copy_v) {
            return function ($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof Data_Maybe.Nothing) {
                        $tco_done = true;
                        return v1;
                    };
                    if (v instanceof Data_Maybe.Just) {
                        if (eq1(v.value0)(end)) {
                            $tco_done = true;
                            return Data_Array.snoc(v1)(end);
                        };
                        if (Data_Boolean.otherwise) {
                            $tco_var_v = Data_Date.adjust(1.0)(v.value0);
                            $copy_v1 = Data_Array.snoc(v1)(v.value0);
                            return;
                        };
                    };
                    throw new Error("Failed pattern match at Main (line 93, column 3 - line 93, column 21): " + [ v.constructor.name, v1.constructor.name ]);
                };
                while (!$tco_done) {
                    $tco_result = $tco_loop($tco_var_v, $copy_v1);
                };
                return $tco_result;
            };
        };
        return go(new Data_Maybe.Just(start))([  ]);
    };
};
var workDaysInMonth = function (s) {
    var $109 = Data_Array.filter(isWorkDay);
    var $110 = daysInMonth(s);
    return function ($111) {
        return $109($110($111));
    };
};
var dailyTransportationCosts = function (refDate) {
    var v = toEnum(2026);
    if (v instanceof Data_Maybe.Just) {
        var $92 = lessThan(Data_Date.year(refDate))(v.value0);
        if ($92) {
            return 17.1;
        };
        return 18.8;
    };
    return 17.1;
};
var baseSalary = function (date) {
    return officialCategorySalary(date) * 2.0;
};
var monthsSalary = function (v) {
    var workDayCount = Data_Array.length(workDaysInMonth(v.value0)(v.value1));
    var transportationCosts = Data_Int.toNumber(workDayCount) * dailyTransportationCosts(v.value0);
    var taxes = officialCategorySalary(v.value0) * taxPercentage(v.value0);
    var monthHolidays = (function () {
        var yearHolidays = Data_Maybe.fromMaybe(Data_Map_Internal.empty)(lookup(Data_Date.year(v.value0))(Holidays.holidays));
        var monthHoliday = function (d) {
            var v1 = lookup1(d)(yearHolidays);
            if (v1 instanceof Data_Maybe.Just) {
                return [ v1.value0 ];
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return [  ];
            };
            throw new Error("Failed pattern match at Main (line 139, column 22 - line 141, column 20): " + [ v1.constructor.name ]);
        };
        return foldMap(monthHoliday)(daysInMonth(v.value0)(v.value1));
    })();
    var additionalCharges = (function () {
        var $97 = eq2(Data_Date.month(v.value0))(Data_Date_Component.December.value);
        if ($97) {
            return [ {
                description: "13\xba sal\xe1rio",
                amount: baseSalary(v.value0)
            } ];
        };
        return [  ];
    })();
    return {
        totalAmount: (baseSalary(v.value0) - taxes) + transportationCosts + foldl(function (sum) {
            return function (v1) {
                return sum + v1.amount;
            };
        })(0.0)(additionalCharges),
        taxes: taxes,
        dailyTransportationCosts: dailyTransportationCosts(v.value0),
        transportationCosts: transportationCosts,
        workDayCount: workDayCount,
        baseSalary: baseSalary(v.value0),
        monthHolidays: monthHolidays,
        additionalCharges: additionalCharges
    };
};
var mkApp = /* #__PURE__ */ React_Basic_Hooks.component("App")(function (currentDate) {
    return bind1(React_Basic_Hooks.useState(monthRange(currentDate)))(function (v) {
        return pure1((function () {
            if (v.value0 instanceof Data_Maybe.Just) {
                var breakdown = monthsSalary(v.value0.value0);
                return div({
                    className: "font-outfit",
                    children: [ monthSelector(v.value1)(Data_Tuple.fst(v.value0.value0)), h2({
                        className: "text-4xl text-center p-8 font-medium",
                        children: [ React_Basic_DOM.text("Delminha embolsa") ]
                    }), totalAmount(breakdown), lineItems(breakdown), monthHolidaysView(breakdown) ]
                });
            };
            if (v.value0 instanceof Data_Maybe.Nothing) {
                return React_Basic_DOM.text("Nothing to see here");
            };
            throw new Error("Failed pattern match at Main (line 289, column 9 - line 306, column 50): " + [ v.value0.constructor.name ]);
        })());
    });
});
var main = function __do() {
    var container = bindFlipped1(Web_DOM_NonElementParentNode.getElementById("app"))(Data_Functor.map(Effect.functorEffect)(Web_HTML_HTMLDocument.toNonElementParentNode)(bindFlipped1(Web_HTML_Window.document)(Web_HTML.window)))();
    if (container instanceof Data_Maybe.Nothing) {
        return Effect_Exception["throw"]("Missing container element")();
    };
    if (container instanceof Data_Maybe.Just) {
        var root = React_Basic_DOM_Client.createRoot(container.value0)();
        var layout = apply1(mkApp)(Effect_Now.nowDate)();
        return React_Basic_DOM_Client.renderRoot(root)(layout)();
    };
    throw new Error("Failed pattern match at Main (line 311, column 3 - line 317, column 29): " + [ container.constructor.name ]);
};
export {
    officialCategorySalary,
    baseSalary,
    taxPercentage,
    dailyTransportationCosts,
    monthStart,
    monthEnd,
    daysInMonth,
    isWorkDay,
    workDaysInMonth,
    monthRange,
    monthsSalary,
    monthSelector,
    formatAmount,
    totalAmount,
    lineItems,
    monthHolidaysView,
    mkApp,
    main
};
//# sourceMappingURL=index.js.map
